import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import { legalServicesData } from "../../../data/legalServicesData";

import HeroSection from "./LegalServicesHome/HeroSection";
import ServicesGrid from "./LegalServicesHome/ServicesGrid";
import WhyChooseUs from "./LegalServicesHome/WhyChooseUs";
import ProcessSection from "./LegalServicesHome/ProcessSection";
import FAQSection from "./LegalServicesHome/FAQSection";
import CTASection from "./LegalServicesHome/CTASection";

const LegalServicesHome = () => {
  const location = useLocation();

  return (
    <motion.main
      key={location.pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: "easeOut",
      }}
      className="overflow-x-hidden bg-[#050505] text-white font-saira"
    >
      {/* Hero */}
      <HeroSection />

      {/* Services */}
      <ServicesGrid data={legalServicesData} />

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* Process */}
      <ProcessSection />

      {/* FAQ */}
      <FAQSection />

      {/* CTA */}
      <CTASection />
    </motion.main>
  );
};

export default LegalServicesHome;